import { useTheme } from '@emotion/react';
import { Button, Tooltip } from '@mui/material';
import { Box, Stack } from '@mui/system';
import React from 'react';
import styled from 'styled-components';
import { useReport } from '../../contexts/ReportContext';
import ColorStyle from '../icons/ColorStyle';
import { colors } from '../../theme';

const StyledBottomBar = styled(Box)`
    position: sticky;
    bottom: 0;
    left:0 ;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E7E5E4;
    padding: 15px;

`;


const StyledColorStyleButton = styled(Button)(({ theme }) => ({
    padding: 0,
    minWidth: 0,
    borderRadius: "50%",
    backgroundColor: "transparent",
    border: "none",
    "&.selected": {
        border: `2px solid ${colors.stone[500]}`
    }
}));

const BottomBar: React.FC = () => {

    const {
        toggleEditMode,
        toggleFooterDialog,
        toggleNotesDialog,
        notesDialogOpen,
        footerDialogOpen,
        colorStyle,
        reportEditMode,
        updateColorStyle

    } = useReport();

    const theme: any = useTheme();

    return (
        <StyledBottomBar>
            <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"space-around"}>
                <Stack width={"100%"} gap={2} direction={"row"} justifyContent={"space-between"}>
                    {Object.keys(theme.palette.reportColorStyles).map((color) => (
                        <Tooltip title={color} key={color}>
                            <StyledColorStyleButton className={colorStyle === color ? "selected" : ""} onClick={() => updateColorStyle(color)}>
                                <ColorStyle lightColor={theme.palette.reportColorStyles[color].light} mainColor={theme.palette.reportColorStyles[color].main} />
                            </StyledColorStyleButton>
                        </Tooltip>
                    ))}
                </Stack>
            </Stack>
        </StyledBottomBar >
    );
};

export default BottomBar;